<template>

    <div v-for="(title, division) in divisions" class="my-3">
        <h4 class="text-center text-slate-500 opacity-90">{{ title }}</h4>

        <div v-for="book in books[division]">
            <a
                class="text-slate-700 inline-block px-4"
                :href="`/${ division }/${ book.url }/1`"
                @click.prevent="openBook(book)"
            >
                {{ book.title }}
            </a>
        </div>
    </div>

</template>

<style scoped>
    
    a {
        color: #0d3b69;
        padding-top: 1px;
        padding-bottom: 1px;
        margin-bottom: 2px;
    }
    
    a:hover {
        background-color: rgba(0, 20, 0, 0.05);
    }

</style>

<script setup>
    import { ref, reactive, inject } from 'vue'

    const tora = ref([])
    const neviim = ref([])
    const ketuvim = ref([])

    const divisions = ref([])


    const books = reactive({
        tora: [],
        neviim: [],
        ketuvim: [],
    })


    const loadBookChapter = inject('loadBookChapter')


    axios.post('/api/scripture/load-books', {
        _token: window.csrfToken
    }).then(response => {
        books.tora = response.data.books?.tora ?? []
        books.neviim = response.data.books?.neviim ?? []
        books.ketuvim = response.data.books?.ketuvim ?? []

        divisions.value = response.data.divisions ?? []
    })



    function openBook(book) {
        loadBookChapter(1, book.url)
    }

</script>